
export default {
  singleLabel: "Affaire",
  storeNamespace: 'business',
  authFeature: 'not-billable-business',
  listRouteName: "NotBillableBusinessList",
  hideActionNewButton: true,
  hideActionEditButton: true,
  hideActionDeleteButton: true,
  hideActionPdfButton: true,
  csvExportFilenamePrefix: 'affaires-non-facturables',
  titleField: 'name',
  sortBy: 'name',
  fields: [
    {
      name: 'agency',
      label: "Agence courante",
      type: 'select',
      inList: true,
      inCsvExport: true,
      sortable: true,
      filterIn: false,
      extendedFilter: true,
      formatter: (context, value) => value && value.internal_number ? value.internal_number : null,
      csvFormatter: (value) => (value && value.internal_number ? value.internal_number : ''),
    },
    {
      name: 'number',
      label: "Affaire courante",
      type: 'text',
      inList: true,
      inCsvExport: true,
      sortable: true,
      filterIn: true,
    },
    {
      name: 'name',
      label: "Libellé de l'affaire",
      type: 'text',
      inList: false,
      inCsvExport: true,
    },
    {
      name: 'references',
      label: "Références uniques",
      type: 'text',
      inList: true,
      inCsvExport: true,
      // Les références sont aplaties dans une colonne, avec leur produit, pour que le
      // responsable d'affaires s'y retrouve sans revenir dans l'outil.
      csvFormatter: (value) => Array.isArray(value)
        ? value.map((reference) => reference.internal_code + ' (' + (reference.product ? reference.product.name : '') + ')').join(' / ')
        : '',
    },
    {
      name: 'services',
      label: "Services",
      type: 'select',
      inList: true,
      inCsvExport: true,
      extendedFilter: true,
      csvFormatter: (value, row) => {
        const services = [];
        const references = (row && row.references) || [];
        if (references.filter((item) => item.product && item.product.group_slug == 'outillage').length) {
          services.push('Outillage');
        }
        if (references.filter((item) => item.product && item.product.group_slug == 'instruments').length) {
          services.push('Instruments');
        }
        if (references.filter((item) => item.product && item.product.group_slug == 'service_et_logistique').length) {
          services.push('Service et logistique');
        }
        return services.join(' / ');
      },
      formatter: (context, value, item) => {
        var services = [];
        if (item) {
          if (item.references && typeof item.references === 'object' && item.references.filter(item => item.product.group_slug == 'outillage').length) {
            services.push('outillage')
          }
          if (item.references && typeof item.references === 'object' && item.references.filter(item => item.product.group_slug == 'instruments').length) {
            services.push('instruments')
          }
          if (item.references && typeof item.references === 'object' && item.references.filter(item => item.product.group_slug == 'service_et_logistique').length) {
            services.push('service_et_logistique')
          }
        }
        return services
      }
    },
    {
      name: 'billable',
      label: "Facturable",
      type: 'text',
      inList: true,
      inCsvExport: true,
      formatter: () => "Non"
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/NotBillableBusiness/config.js